import axios from "axios";

export const snapshotsCompare = async (
  userPrompt: string,
  conversationId: string,
  rows: { documentName: string; text: string }[],
) => {
  await axios.post("/pf-mainweb/business-reports/snapshots-compare", {
    user_prompt: userPrompt,
    conversation_id: conversationId,
    rows: rows.map(row => ({ document_name: row.documentName, text: row.text })),
  });
};
